import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../../api/api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { Field } from "../../../types/TenantInterfaces";

interface Props {
  fileRecordID: string;
  onSuccess?: (fields?: Field[]) => void;
  onError?: (err: string) => void;
}

// Creates a Field schema array from a CSV/Excel file
// (doesn't create a new module, allows user to review fields first)
const useCreateModuleFromCSV = () => {
  const createModuleFromCSV = useMutation({
    mutationFn: ({ fileRecordID }: Props) => {
      return TenantAPI.createModuleFromCSV({
        fileRecordID,
      }).then((data) => data.data.data.fields as Field[]);
    },
    onSuccess: (schema, { onSuccess }) => {
      callFunctionIfExists(onSuccess, schema);
    },
    onError: (err, { onError }) => {
      callFunctionIfExists(onError, getErrorMessage(err));
    },
  });

  return {
    createModuleFromCSV: createModuleFromCSV.mutate,
    creatingModule: createModuleFromCSV.isPending,
    createModuleError: createModuleFromCSV.error
      ? getErrorMessage(createModuleFromCSV.error)
      : null,
  };
};

export default useCreateModuleFromCSV;
